import './App.css';
import './css/fontawesome-free-6.2.1-web/css/all.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from 'react';
import { 
  Home,
  Navbar,
  About,
  Project,
  Python,
  Js,
  NodeJs,
  ReactJs,
  HTML,
  CSS,
  CommingSoon,
  ColorSettings,
  Blog,
  JavaScript,
  PythonCheat,
  HtmlCss,
  SoftwareEngineering,
  UiUx,
  JavaCheatsheet,
  ReactNative
} from './Components'
function App() {
  let [color, setColor] = useState('')
  let [value, setvalue] = useState(false)
  const toggleMode = (cls,isvalue) => {
    setColor(cls)
    setvalue(isvalue)
  }
  return (
    <>
      <div className="body">
        <Router basename='/zer0ne'>
          <Navbar mode={color} isValue={value} />
          <ColorSettings mode={color} isValue={value} toggleMode={toggleMode} />
          <Routes>
            <Route exact path="/" element={<Home mode={color} isValue={value}  />} />
            <Route path="/about" element={<About mode={color} isValue={value}  />} />
            <Route path="/project" element={<Project mode={color} isValue={value}  />} />
            <Route path="/project/python" element={<Python mode={color} isValue={value}  />} />
            <Route path="/project/js" element={<Js mode={color} isValue={value}  />} />
            <Route path="/project/nodejs" element={<NodeJs mode={color} isValue={value}  />} />
            <Route path="/project/reactjs" element={<ReactJs mode={color} isValue={value}  />} />
            <Route path="/project/react-native" element={<ReactNative  />} />
            <Route path="/project/html" element={<HTML />} />
            <Route path="/project/css" element={<CSS  />} />
            <Route path='/blog' element={<Blog mode={color} isValue={value} />} />
            <Route path='/blog/javascript-cheetsheet' element={<JavaScript  mode={color} isValue={value} />} />
            <Route path='/blog/python-cheetsheet' element={<PythonCheat  mode={color} isValue={value} />} />
            <Route path='/blog/java-cheatsheet' element={<JavaCheatsheet  mode={color} isValue={value} />} />
            <Route path='/blog/html-css-cheatsheet' element={<HtmlCss  mode={color} isValue={value} />} />
            <Route path='/blog/software-cheatsheet' element={<SoftwareEngineering  mode={color} isValue={value} />} />
            <Route path='/blog/ui-ux-cheatsheet' element={<UiUx  mode={color} isValue={value} />} />
            {/* <Route path='/zer0ne/blog' element={<CommingSoon />} /> */}
            <Route path='/contact' element={<CommingSoon />} />
          </Routes>
        </Router>
      </div>
    </>
  );
}
export default App;